import React from "react";
import { FbVerifiedBadge, GoogleReviewPill, StoreReviewPill } from "./VerifiedBadges";

/* ============================ Shared Brand Header ============================ */
export default function BrandHeader({ showRating = true }) {
  return (
    <>
      <header data-testid="brand-header" className="bg-gradient-to-r from-[#0f5132] via-[#0f5132] to-[#16794c] text-white">
        <div className="px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            <div
              data-testid="brand-logo"
              className="w-11 h-11 rounded-xl bg-amber-400 grid place-items-center text-emerald-900 font-black text-2xl shadow-md shrink-0"
              style={{ boxShadow: "0 4px 14px -3px rgba(245,158,11,0.55)" }}
            >
              M
            </div>
            <div className="leading-tight min-w-0">
              <div className="font-display text-[20px] font-extrabold tracking-tight text-white">
                make2shine<sup className="text-[9px] ml-0.5">®</sup>
              </div>
              <div className="text-[10px] text-emerald-100/90 font-semibold tracking-[0.15em] uppercase">
                Premium Cleaning Expert
              </div>
            </div>
          </div>
          <FbVerifiedBadge />
        </div>
      </header>

      {/* Dark navy delivery bar */}
      <div
        className="px-4 py-2.5 text-center"
        style={{ background: "#0c1f3a", color: "#fde047" }}
        data-testid="delivery-bar"
      >
        <div className="flex items-center justify-center gap-3 text-[12.5px] font-extrabold flex-wrap">
          <span className="inline-flex items-center gap-1.5">📦 Cash on Delivery Available</span>
          <span className="text-amber-300/60">◆</span>
          <span className="inline-flex items-center gap-1.5">🚚 Free Delivery All Over India</span>
        </div>
      </div>

      {showRating && (
        <div className="px-4 pt-3" data-testid="rating-strip">
          <div className="grid grid-cols-2 gap-2">
            <div className="flex items-center justify-center"><GoogleReviewPill /></div>
            <div className="flex items-center justify-center"><StoreReviewPill /></div>
          </div>
        </div>
      )}
    </>
  );
}
